import type { AnalyticsMetricId } from '@reelplicate/api-client/model';

/** How each metric card is labelled and coloured (a `viz-*` token), in Figma order. */
export const METRIC_META: Record<AnalyticsMetricId, { label: string; color: string }> = {
  views: { label: 'Views', color: 'var(--color-viz-olive)' },
  likes: { label: 'Likes', color: 'var(--color-viz-magenta)' },
  comments: { label: 'Comments', color: 'var(--color-viz-sky)' },
  shares: { label: 'Shares', color: 'var(--color-viz-orange)' },
  saves: { label: 'Saves', color: 'var(--color-viz-violet)' },
  followers: { label: 'Followers', color: 'var(--color-viz-teal)' },
};

/** "2026-09-25" (a UTC day from the API) → local midnight of that date, for display. */
export function parseDay(iso: string): Date {
  const [year, month, day] = iso.split('-').map(Number) as [number, number, number];
  return new Date(year, month - 1, day);
}

/** A local date → "2026-09-25", the day the person picked (never shifted by toISOString's UTC). */
export function toIsoDay(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
